import vue from 'vue'
import Vuex from 'vuex'
vue.use(Vuex)

import { getEventTags, getEvents, getEventContent, getAllEvents, getSingleMonthEvents } from "../api/api_event"
import { getNews, getNewsContent } from "../api/api_news"

const store = new Vuex.Store({
    state: {
        eventTag: [],
        eventList: [],
        eventListAll: [],
        event: {},
        currentTag: "全部",
        newsData: [],
        news: {}
    },
    mutations: {

    },
    actions: {
        async getEvent({ commit, state }, opt) {
            state.eventTag = (await getEventTags()).data
            state.currentTag = "全部"
            state.eventList = (await getEvents('', 0, 10)).data.list
        },
        async getAllEvent({ commit, state }) {
            state.eventListAll = (await getAllEvents()).data.list
        },
        async getSingleMonthEvents({ commit, state }, query) {
            state.eventList = (await getSingleMonthEvents(query)).data
        },
        async getEventByTag({ commit, state }, opt) {
            state.eventTag = (await getEventTags()).data
            if (state.currentTag == '全部') {
                state.eventList = (await getEvents('', opt.offset, opt.length)).data
            } else {
                state.eventList = (await getEvents(state.currentTag, opt.offset, opt.length)).data
            }
        },
        async getEventContent({ commit, state }, id) {
            state.event = (await getEventContent(id)).data
            return state.event
        },
        async getNews({ commit, state }, opt) {
            state.newsData = (await getNews(opt.offset, opt.length)).data
        },
        async getNewsContent({ commit, state }, id) {
            state.news = (await getNewsContent(id)).data
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js